import { render } from "./Widgets.vue?vue&type=template&id=1dbbb1b4&scoped=true&ts=true"
import script from "./Widgets.vue?vue&type=script&lang=ts"
export * from "./Widgets.vue?vue&type=script&lang=ts"

import "./Widgets.vue?vue&type=style&index=0&id=1dbbb1b4&scoped=true&lang=css"

import exportComponent from "/Users/rickvanwell/Work/Signals/webui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbbb1b4"]])

export default __exports__